// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__18M8a","row":"Node_row__1OoJq","label":"Node_label__3GnYN","footer":"Node_footer__2laBE"};